import { EvaluationEntry } from '../MultipleEvaluations';

export const dogPainEvaluations: EvaluationEntry[] = [
  {
    label: 'Pain upon manipulation',
    value: 'pain_on_manipulation'
  },
  {
    label: 'Passive range of movement',
    value: 'passive_range_of_movement'
  }
];

export const equinePainEvaluations: EvaluationEntry[] = [
  {
    label: 'Pain upon Palpation',
    value: 'pain_on_palpation'
  },
  {
    label: 'Pain upon Articulation',
    value: 'pain_on_articulation'
  }
];

export const felinePainEvaluations: EvaluationEntry[] = [
  {
    label: 'Pain upon manipulation',
    value: 'pain_on_manipulation'
  },
  {
    label: 'Passive range of movement',
    value: 'passive_range_of_movement'
  }
];

const painEvaluations = {
  dogPainEvaluations,
  equinePainEvaluations,
  felinePainEvaluations
} as const;

export type PainEvaluationSetName = keyof typeof painEvaluations;
export const PainEvaluationSets: Record<PainEvaluationSetName, EvaluationEntry[]> = painEvaluations;
